<template>
  <div>
    <h1 class="text-center">Product Master</h1>
    <div>
      <List />
    </div>
  </div>
</template>

<script>
import List from "./ListProduct.vue";
export default {
  components: {
    List,
  },
};
</script>
